import React, { useState, useRef, useEffect } from "react";
import "../../../style.css";

const FullReader = ({ pages, onScroll }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const comicContainerRef = useRef(null);

  const toggleFullScreen = () => {
    const element = comicContainerRef.current;
    if (!isFullScreen) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen(); // For Firefox
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(); // For Chrome, Safari, Opera
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen(); // For IE/Edge
      }
      setIsFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen(); // For Firefox
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen(); // For Chrome, Safari, Opera
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen(); // For IE/Edge
      }
      setIsFullScreen(false);
    }
  };

  // Handle touch events
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const touchStartY = useRef(0);
  const touchEndY = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
    touchEndY.current = e.touches[0].clientY;

    const swipeDistanceX = touchStartX.current - touchEndX.current;
    const swipeDistanceY = touchStartY.current - touchEndY.current;

    // Block horizontal swipes, but allow vertical scrolling
    if (Math.abs(swipeDistanceX) > Math.abs(swipeDistanceY)) {
      e.preventDefault();
    }
  };

  const handleTouchEnd = () => {
    const swipeDistanceX = touchStartX.current - touchEndX.current;
    const swipeDistanceY = touchStartY.current - touchEndY.current;

    // Only allow swipe if the horizontal movement is greater than the vertical movement
    if (Math.abs(swipeDistanceX) > Math.abs(swipeDistanceY)) {
      if (swipeDistanceX > 30) {
        // Swipe left: Next page
      } else if (swipeDistanceX < -30) {
        // Swipe right: Previous page
      }
    }
  };

  // Handle keyboard navigation (optional, you can keep it if you need)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        // Handle right arrow key press (e.g., next page)
      } else if (e.key === "ArrowLeft") {
        // Handle left arrow key press (e.g., previous page)
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className={`comic-reader ${isFullScreen ? "fullscreen" : ""}`}>
      <div
        className="comic-container"
        ref={comicContainerRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          overflow: isFullScreen ? "hidden" : "visible",
          height: isFullScreen ? "100vh" : "auto",
          touchAction: "auto", // Allow default scroll behavior
        }}
      >
<div
  style={{
    height: isFullScreen ? "100vh" : "80vh",
    overflowY: "scroll",
    padding: 0,
    margin: 0,
  }}
  onScroll={onScroll}
>
          {pages.map((page, index) => (
            <img
              key={index}
              src={page}
              alt={`Page ${index + 1}`}
              onClick={toggleFullScreen}
              loading="lazy"
              className={isFullScreen ? "fullscreen-image" : ""}
            />
          ))}
        </div>

        {/* Fullscreen Exit Button */}
        {isFullScreen && (
          <button
            onClick={toggleFullScreen}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              fontSize: "24px",
              color: "#fff",
              background: "none",
              border: "none",
              cursor: "pointer",
              zIndex: 10,
            }}
          >
            X
          </button>
        )}
      </div>
    </div>
  );
};

export default FullReader;
